import React from "react";
import { FiX } from "react-icons/fi";
import { LuLogOut } from "react-icons/lu";
import { Globe, CreditCard, BarChart2, Circle } from "lucide-react";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLogoutMutation } from "../../Redux/userApi";
import { useApiToast } from "../Toast/useApiToast";
// import { Circle } from "@tabler/icons-react";
// import { IconCircleDot } from "@tabler/icons-react";
import { IconCircleDot } from "@tabler/icons-react";
import { SiCircle } from "react-icons/si";

import {
    clearUser,
    selectAvatar,
    selectDisplayName,
    selectEmail,
    selectInitials,
} from "../../Redux/authSlice";
import { useAppDispatch } from "../../Redux/hooks";
import zeroTypingLogo from "../../Asset/ZEROTyingLogo.svg";
import sideBarLogo from "../../Asset/ZT-Sidebar-logo.svg";
import arrowCollapsed from "../../Asset/ArrowCollapsed.svg";
import arrowExpanded from "../../Asset/ArrowExpanded.svg";


const topNavigation = [
    {
        name: "Web App",
        icon: <Globe size={18} />,
        link: "/app",
    },
    {
        name: "Manage Subscription",
        icon: <CreditCard size={18} />,
        link: "/settings",
    },
    {
        name: "Usage",
        icon: <SiCircle size={18} />,
        link: "/usage",
    },
];

const Sidebar = ({
    openSidebar,
    setOpenSidebar,
    openSidebarMobile,
    setOpenSidebarMobile,
}) => {
    const { showToast } = useApiToast();

    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const avatar = useSelector(selectAvatar);
    const name = useSelector(selectDisplayName);
    const email = useSelector(selectEmail);
    const initials = useSelector(selectInitials);
    const [logout] = useLogoutMutation();
    const handleLogout = async () => {
        try {
            const response = await logout({}).unwrap();

            if (response?.success) {
                showToast(response?.message || "Logged out successfully", "success");
                dispatch(clearUser());
                navigate("/login", { replace: true });
            }
        } catch (error) {
            showToast("Logout failed", "error");
            dispatch(clearUser());
            navigate("/login", { replace: true });
        }
    };

    const userNavigation = [
        {
            name: "Sign Out",
            icon: <LuLogOut className=" size-5" />,
            buttonColor: "text-[#111827] hover:bg-[#F3F4F6]",
            onclick: () => handleLogout(),
        },
    ];


    return (
        <>
            <div
                className={`lg:block hidden fixed top-0 bottom-0 z-[120] ${!openSidebar ? " w-16" : "xl:w-[260px] w-[200px]"
                    } transition-all duration-500 ease-in-out`}
            >
                <button
                    type="button"
                    onClick={() => setOpenSidebar(!openSidebar)}
                    aria-label={openSidebar ? "Close Sidebar" : "Open Sidebar"}
                    className={`z-[130] absolute transition-all duration-300 cursor-pointer bg-[#39A7F2] hover:bg-[#2596E7] text-white border border-[#39A7F2] rounded-full p-1.5 aspect-square -right-3 top-[88px] -translate-y-1/2 shadow-sm`}
                >
                    <img
                        src={openSidebar ? arrowExpanded : arrowCollapsed}
                        alt=""
                        aria-hidden="true"
                        className="w-[12px] h-[12px] object-contain"
                    />
                </button>

                <div className="relative w-full h-screen flex flex-col justify-between overflow-y-auto scrollbar-hide py-0 border-r border-[#E5E7EB] bg-[#FFFFFF]">
                    <div className="flex flex-col">
                        <div className={`h-[88px] border-b border-[#E5E7EB] px-3 flex items-center ${!openSidebar ? "justify-center" : "justify-start"}`}>
                            <NavLink to="/" className="inline-flex items-center" aria-label="Go to website">
                                <img
                                    src={!openSidebar ? sideBarLogo : zeroTypingLogo}
                                    className={`${!openSidebar ? "w-9 h-9 object-contain" : "w-[170px] object-contain"}`}
                                    alt="Zero Typing"
                                />
                            </NavLink>
                        </div>

                        <div className="flex flex-col gap-1 px-2 py-5">
                            {topNavigation?.map((link, i) => (
                                <NavLink
                                    className={({ isActive }) =>
                                        `flex items-center ${!openSidebar ? "justify-center" : "justify-start"} gap-3 rounded-xl border transition-all ${!isActive
                                            ? "text-[#4B5563] border-transparent hover:bg-[#F3F4F6]"
                                            : "text-[#1D9BF0] bg-[#DDF0FF] border-[#92CDF9]"
                                        } text-sm ${!openSidebar ? "p-3" : "p-2 w-full"
                                        } `
                                    }
                                    key={i}
                                    to={link.link}
                                >
                                    {link.icon}
                                    <span className={`${!openSidebar ? "hidden" : "flex"} font-medium`}>
                                        {link?.name}
                                    </span>
                                </NavLink>
                            ))}
                        </div>
                    </div>


                    <div className="flex flex-col border-t border-[#E5E7EB] px-2 py-3">
                        {openSidebar && (
                            <div className="flex items-center md:gap-3 gap-2 md:p-3 p-2 md:rounded-2xl rounded-lg bg-[#F7F7F8] mx-1 mb-2">
                                {avatar ? (
                                    <img
                                        src={avatar}
                                        alt="Profile"
                                        className="md:h-12 h-10 md:w-12 w-10 rounded-full object-cover"
                                        referrerPolicy="no-referrer"
                                    />
                                ) : (
                                    <div className="md:h-12 h-10 md:w-12 w-10 rounded-full bg-[#EDF2F7] text-[#353535] grid place-items-center font-semibold">
                                        {initials || "U"}
                                    </div>
                                )}

                                <div className="min-w-0 text-left">
                                    <div className="truncate md:text-base text-sm font-bold text-[#353535]">
                                        {name || "Account"}
                                    </div>
                                    <div
                                        className="truncate md:text-sm text-xs text-[#3535359E]"
                                        title={email}
                                    >
                                        {email || "—"}
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className="flex flex-col gap-1">
                            {userNavigation?.map((link, i) => {
                                if (link.link) {
                                    return (
                                        <NavLink
                                            key={i}
                                            to={link.link}
                                            className={({ isActive }) =>
                                                `flex items-center gap-3 rounded-lg transition-all ${link?.buttonColor ? link.buttonColor :
                                                    (!isActive ? "text-[#4B5563] hover:bg-[#F3F4F6]"
                                                        : "text-[#1D9BF0] bg-[#DDF0FF] border border-[#92CDF9]")
                                                } text-sm ${!openSidebar ? "p-3 justify-center" : "px-3 py-3 w-full"}`
                                            }
                                        >
                                            {link.icon}
                                            <span className={`${!openSidebar ? "hidden" : "flex"} font-medium`}>
                                                {link.name}
                                            </span>
                                        </NavLink>
                                    );
                                } else {
                                    return (
                                        <button
                                            key={i}
                                            onClick={link.onclick}
                                            type="button"
                                            className={`flex items-center gap-3 rounded-lg transition-all ${link?.buttonColor ? link.buttonColor : "text-[#4B5563] hover:bg-[#F3F4F6]"
                                                } text-sm ${!openSidebar ? "p-3 justify-center" : "px-3 py-3 w-full"}`}
                                        >
                                            {link.icon}
                                            <span className={`${!openSidebar ? "hidden" : "flex"} font-medium`}>
                                                {link.name}
                                            </span>
                                        </button>
                                    );
                                }
                            })}
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`fixed lg:hidden inset-0 bg-black/25 transition-opacity duration-300 z-[160] ${openSidebarMobile ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
                    }`}
                onClick={() => setOpenSidebarMobile(false)}
            />
            <div
                className={`fixed lg:hidden flex flex-col w-[75%] inset-y-0 left-0 bg-white transition-transform duration-700 ease-in-out h-[100dvh] z-[170] ${openSidebarMobile ? "translate-x-0" : "-translate-x-[105%]"
                    }`}
            >
                <div className="w-full px-4 h-[72px] flex justify-start border-b border-[#E5E7EB] items-center gap-2">
                    <button
                        type="button"
                        onClick={() => setOpenSidebarMobile(false)}
                        className="outline-0 text-[#374151]"
                    >
                        <FiX className=" size-6" />
                    </button>
                    <NavLink to="/" onClick={() => setOpenSidebarMobile(false)} aria-label="Go to website">
                        <img src={zeroTypingLogo} className="w-[140px] object-contain" alt="logo" />
                    </NavLink>

                </div>
                <div className="relative w-full h-[calc(100dvh-72px)] max-h-[calc(100dvh-72px)] flex flex-col gap-3 overflow-y-auto scrollbar-hide py-4 pb-[calc(env(safe-area-inset-bottom)+16px)]">
                    <div className="flex flex-col pb-3 px-3">
                        <div className="flex flex-col gap-1">
                            {topNavigation?.map((link, i) => (
                                <NavLink
                                    className={({ isActive }) =>
                                        `flex items-center gap-3 rounded-xl border transition-all ${!isActive
                                            ? "text-[#4B5563] border-transparent hover:bg-[#F3F4F6]"
                                            : "text-[#1D9BF0] bg-[#DDF0FF] border-[#92CDF9]"
                                        } text-sm p-2 w-full `
                                    }
                                    key={i}
                                    to={link.link}
                                    onClick={() => setOpenSidebarMobile(false)}
                                >
                                    {link.icon}
                                    <span className="font-medium">{link?.name}</span>
                                </NavLink>
                            ))}
                        </div>
                    </div>
                    <div className="mt-auto flex flex-col gap-3 border-t border-[#E5E7EB] pt-3 px-3">
                        <div className="flex items-center md:gap-3 gap-2 md:p-3 p-2 md:rounded-2xl rounded-lg bg-[#F7F7F8]">
                            {avatar ? (
                                <img
                                    src={avatar}
                                    alt="Profile"
                                    className="md:h-12 h-10 md:w-12 w-10 rounded-full object-cover"
                                    referrerPolicy="no-referrer"
                                />
                            ) : (
                                <div className="md:h-12 h-10 md:w-12 w-10 rounded-full bg-[#EDF2F7] text-[#353535] grid place-items-center font-semibold">
                                    {initials || "U"}
                                </div>
                            )}
                            <div className="min-w-0 text-left">
                                <div className="truncate md:text-base text-sm font-bold text-[#353535]">
                                    {name || "Account"}
                                </div>
                                <div className="truncate md:text-sm text-xs text-[#3535359E]" title={email}>
                                    {email || "—"}
                                </div>
                            </div>
                        </div>
                        <div className="flex flex-col gap-1">
                            {userNavigation?.map((link, i) => {
                                if (link.link) {
                                    return (
                                        <NavLink
                                            key={i}
                                            to={link.link}
                                            className={({ isActive }) =>
                                                `flex items-center gap-3 rounded-lg transition-all ${link?.buttonColor ? link.buttonColor :
                                                    (!isActive ? "text-[#4B5563] hover:bg-[#F3F4F6]"
                                                        : "text-[#1D9BF0] bg-[#DDF0FF] border border-[#92CDF9]")
                                                } text-sm px-4 py-3 w-full`
                                            }
                                        >
                                            {link?.icon} <span className="font-medium">{link?.name}</span>
                                        </NavLink>
                                    );
                                } else {
                                    return (
                                        <button
                                            key={i}
                                            type="button"
                                            onClick={() => {
                                                if (link.onclick) link.onclick();
                                                setOpenSidebarMobile(false);
                                            }}
                                            className={`flex items-center gap-3 rounded-lg transition-all ${link?.buttonColor ? link.buttonColor : "text-[#4B5563] hover:bg-[#F3F4F6]"
                                                } text-sm px-4 py-3 w-full`}
                                        >
                                            {link?.icon} <span className="font-medium">{link?.name}</span>
                                        </button>
                                    );
                                }
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Sidebar;
